import { isIOS as isIOSUserAgent } from '@fluentui/react';
import { pageDataService } from 'common/utilities';
import { isIOS, isWindows } from 'store';
import { useWebView } from 'store/webView/useWebView';

export function isWindowsUserAgent() {
  if (!window || !window.navigator || !window.navigator.userAgent) {
    return false;
  }
  return /Windows/i.test(navigator.userAgent);
}

const usePlatform = () => {
  const { isWebView, webViewPlatform } = useWebView();
  const platformOverride = localStorage.getItem('platformOverride');
  const shouldSimulateIOS = !pageDataService.isProdEnvironment() && platformOverride === 'iOS';
  const isIOSDevice = shouldSimulateIOS || (isWebView && isIOS(webViewPlatform)) || isIOSUserAgent();
  const isWindowsDevice = (isWebView && isWindows(webViewPlatform)) || isWindowsUserAgent();
  return { isIOSDevice, isWindowsDevice };
};

export default usePlatform;
